// Register.ts
import Axios from 'axios';

import Env from './Env';

import { SetListDataSingle } from '../interface/Data';

interface HandleDataResponse {
    status_data: boolean;
}

interface ProjectResponse {
    status_data       : boolean;
    projects?         : any;
    link_project?     : string;
    show_logo_project?: string;
}

// Arquivo já salvo no servidor vem como string (url); arquivo novo vem como File
export interface BkImageItem {
    file   : File | string | null;
    status : boolean;
}

export interface ProjectFormData {
    idPage        : number;
    company       : number;
    typeRegister  : number;
    nameProject     : string;
    nameLinkProject : string;
    linkProject     : string;
    unitType      : string;
    otherUnitType : string[];
    latitude      : string;
    longitude     : string;
    countryName   : string;
    countrySigla  : string;
    postalCode    : string;
    iconMap       : File | string | null;
    logo          : File | string | null;
    bkImage       : BkImageItem[];
}

export async function Reg_Project(dataProject: ProjectFormData): Promise<ProjectResponse> {
    try {
        const data = new FormData();

        data.append('type_page', 'projects');
        data.append('type_data', 'edit_or_register');
        data.append('token', localStorage.getItem('token') || '');

        data.append('id', String(dataProject.idPage));
        data.append('company', String(dataProject.company));
        data.append('type_register', String(dataProject.typeRegister));
        data.append('name_project', dataProject.nameProject);
        data.append('name_link_project', dataProject.nameLinkProject);
        data.append('link_project', dataProject.linkProject);
        data.append('unit_type', dataProject.unitType);
        data.append('other_unit_type', JSON.stringify(dataProject.otherUnitType));
        data.append('latitude', dataProject.latitude);
        data.append('longitude', dataProject.longitude);
        data.append('country_name', dataProject.countryName);
        data.append('country_sigla', dataProject.countrySigla);
        data.append('postal_code', dataProject.postalCode);
        data.append('icon_map', dataProject.iconMap ?? '');
        data.append('logo', dataProject.logo ?? '');

        data.append('qtd_bkImage', String(dataProject.bkImage.length));
        dataProject.bkImage.forEach((elem, index) => {
            data.append('bk_image_' + index, elem.file ?? '');
        });

        const response = await Axios.post<ProjectResponse>(Env.apiUrl, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        if(response.data.status_data && response.data.projects){
            SetListDataSingle('projects', response.data.projects);
        }

        return response.data;

    }catch (error){
        return { status_data: false };
    }
}

// Salva a alteração de um único campo do projeto (publish_on_home, publish_on_map,
// year_release, year_sale, value_sold) sem recarregar a listagem inteira.
export async function Reg_ProjectHandleData(id: number, field: string, value: string | number): Promise<boolean> {
    try {
        const response = await Axios.post<HandleDataResponse>(Env.apiUrl, {
            type_page: 'projects',
            type_data: 'handle_data',
            field: field,
            id: id,
            value: value,
            token: localStorage.getItem('token')
        });

        return response.data.status_data === true;

    }catch (error){
        return false;
    }
}
